import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  private PORTAL_VERSION_URL_SUFFIX: string = '/api/web/portal/version';
  private PORTAL_SUPPORT_TICKET_URL_SUFFIX: string = '/api/web/portal/supportTicketUrl';
  private PORTAL_USER_MANUAL_URL_SUFFIX: string = '/api/web/portal/userManualUrl';

  constructor(private http: HttpClient, private apiLocationService: ApiLocationService) {
  }

  public getPortalVersion(): Observable<any> {
    const url: string = this.apiLocationService.getLocation() + this.PORTAL_VERSION_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public getSupportTicketUrl(): Observable<any> {
    const url: string = this.apiLocationService.getLocation() + this.PORTAL_SUPPORT_TICKET_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public getUserManualUrl(): Observable<any> {
    const url: string = this.apiLocationService.getLocation() + this.PORTAL_USER_MANUAL_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }
}
